import {
  EVENTS,
  CONFIG,
  EVENT_TYPES,
  NOTIFICATIONS,
  UNIT,
} from '../../utils/constants';
import store from '@/store';
import { getUnitProposersInfo } from '@/utils';
import { toDefaultTimezone } from '../../utils/stringUtils';
import requestService from '../../services/request';
import moment from 'moment-timezone';
import { sha1 } from '../../services/encrypt';
let eventPromise = null;
export default {
  state: {
    generic: [],
    agi: null,
    allocationEquityAssembly: null,
    allocationEquityVisit: null,
    keyDelivery: null,
    inspection: null,
    technicalAssistance: null,
    schedule: [],
    appointment: [],
    event: [],
    scheduleParams: null,
    loadingSchedule: false,
    loadingTechnicalAssistance: false,
    technicalAssistanceParams: null,
  },
  getters: {
    [EVENTS.GET_GENERIC]: (state) => state.generic,
    [EVENTS.GET_AGI]: (state) => state.agi,
    [EVENTS.GET_ALLOCATIONEQUITYASSEMBLY]: (state) =>
      state.allocationEquityAssembly,
    [EVENTS.GET_ALLOCATIONEQUITYVISIT]: (state) => state.allocationEquityVisit,
    [EVENTS.GET_KEYDELIVERY]: (state) => state.keyDelivery,
    [EVENTS.GET_INSPECTION]: (state) => state.inspection,
    [EVENTS.GET_TECHNICAL_ASSISTANCE]: (state) => state.technicalAssistance,
    [EVENTS.GET_SCHEDULE]: (state) => state.schedule,
    [EVENTS.GET_APPOINTMENT]: (state, getters) => {
      const technicalAssistance =
        getters[EVENTS.GET_TECHNICAL_ASSISTANCE] || [];
      const schedule = getters[EVENTS.GET_SCHEDULE];
      const generic = getters[EVENTS.GET_GENERIC];
      const agi = getters[EVENTS.GET_AGI];
      const allocationEquityAssembly =
        getters[EVENTS.GET_ALLOCATIONEQUITYASSEMBLY];
      const allocationEquityVisit = getters[EVENTS.GET_ALLOCATIONEQUITYVISIT];
      const keyDelivery = getters[EVENTS.GET_KEYDELIVERY];
      const inspection = getters[EVENTS.GET_INSPECTION];

      const data = [];

      // GENERIC
      if (generic && generic.length) data.push(...generic);

      // AGI
      if (agi && agi._id != null) data.push(agi);

      // Allocation Equity Assembly
      if (allocationEquityAssembly && allocationEquityAssembly._id != null)
        data.push(allocationEquityAssembly);

      // Allocation Equity Visit
      if (allocationEquityVisit && allocationEquityVisit._id != null)
        data.push(allocationEquityVisit);

      // Key Delivery
      if (keyDelivery && keyDelivery._id != null) {
        if (
          !schedule.find((event) => event.typeEvent === EVENT_TYPES.keyDelivery)
        ) {
          data.push(keyDelivery);
        }
      }

      // Inspection
      if (inspection && inspection._id != null) {
        if (
          !schedule.find((event) => event.typeEvent === EVENT_TYPES.inspection)
        ) {
          data.push(inspection);
        }
      }

      let event = [];
      if (data !== null && data.length > 0) {
        event = data.map((item) => ({
          _id: item._id,
          createdAt: item.createdAt,
          date: item.date,
          hour: moment(item.date).format('HH:mm'),
          day: moment(item.date).format('DD/MM'),
          weekDay: moment(item.date).format('ddd'),
          title: item.title,
          description: item.description,
          place: item.address,
          typeEvent: item.type,
          notificationOnly: item.notificationOnly,
          notificationLink: item.notificationLink,
        }));
      }

      let result = [...technicalAssistance, ...schedule, ...event];
      result = filterDataBySameOrAfterDate(result);

      if (result === null) result = [];

      return result.sort((a, b) => (a.date < b.date ? 1 : -1));
    },
  },
  mutations: {
    [EVENTS.RESET_TECHNICAL_ASSISTANCE_CACHE]: (state) => {
      state.technicalAssistanceParams = null;
    },
    [EVENTS.SET_GENERIC]: (state, payload) => {
      state.generic = Array.isArray(payload) ? payload : [payload];
    },
    [EVENTS.UPDATE_GENERIC]: (state, payload) => {
      let newGeneric = Array.isArray(payload) ? payload : [payload];

      // if (newGeneric) {
      //   newGeneric = {
      //     ...(state.generic || {}),
      //     ...newGeneric
      //   };
      // }
      state.generic = newGeneric;
    },
    [EVENTS.SET_AGI]: (state, payload) => {
      state.agi = Array.isArray(payload) ? payload[0] : payload;
    },
    [EVENTS.UPDATE_AGI]: (state, payload) => {
      let newAgi = Array.isArray(payload) ? payload[0] : payload;

      if (newAgi) {
        newAgi = {
          ...(state.agi || {}),
          ...newAgi,
        };
      }
      state.agi = newAgi;
    },
    [EVENTS.SET_ALLOCATIONEQUITYASSEMBLY]: (state, payload) => {
      state.allocationEquityAssembly = Array.isArray(payload)
        ? payload[0]
        : payload;
    },
    [EVENTS.UPDATE_ALLOCATIONEQUITYASSEMBLY]: (state, payload) => {
      let newAllocationEquityAssembly = Array.isArray(payload)
        ? payload[0]
        : payload;

      if (newAllocationEquityAssembly) {
        newAllocationEquityAssembly = {
          ...(state.allocationEquityAssembly || {}),
          ...newAllocationEquityAssembly,
        };
      }
      state.allocationEquityAssembly = newAllocationEquityAssembly;
    },
    [EVENTS.SET_ALLOCATIONEQUITYVISIT]: (state, payload) => {
      state.allocationEquityVisit = Array.isArray(payload)
        ? payload[0]
        : payload;
    },
    [EVENTS.UPDATE_ALLOCATIONEQUITYVISIT]: (state, payload) => {
      let newAllocationEquityVisit = Array.isArray(payload)
        ? payload[0]
        : payload;

      if (newAllocationEquityVisit) {
        newAllocationEquityVisit = {
          ...(state.allocationEquityVisit || {}),
          ...newAllocationEquityVisit,
        };
      }
      state.allocationEquityVisit = newAllocationEquityVisit;
    },
    [EVENTS.SET_KEYDELIVERY]: (state, payload) => {
      state.keyDelivery = Array.isArray(payload) ? payload[0] : payload;
    },
    [EVENTS.UPDATE_KEYDELIVERY]: (state, payload) => {
      if (store.getters[UNIT.GET_SELECTED].keyDeliveryDate) {
        state.keyDelivery = null;
      } else {
        let newKeyDelivery = Array.isArray(payload)
          ? payload.slice(-1)[0]
          : payload;

        if (newKeyDelivery) {
          newKeyDelivery = {
            ...(state.keyDelivery || {}),
            ...newKeyDelivery,
          };
          newKeyDelivery.notificationOnly = true;
          newKeyDelivery.notificationLink = {
            name: 'keyDeliverySchedule',
          };
        }
        state.keyDelivery = newKeyDelivery;
      }
    },
    [EVENTS.SET_INSPECTION]: (state, payload) => {
      state.inspection = Array.isArray(payload) ? payload[0] : payload;
    },
    [EVENTS.UPDATE_INSPECTION]: (state, payload) => {
      let newInspection = null;
      if (Array.isArray(payload)) {
        newInspection = payload.slice(-1)[0];
      } else {
        newInspection = payload;
      }

      if (newInspection) {
        newInspection = {
          ...(state.inspection || {}),
          ...newInspection,
        };
        newInspection.notificationOnly = true;
        newInspection.notificationLink = {
          name: 'inspectionDetails',
        };
      }
      state.inspection = newInspection;
    },
    [EVENTS.SET_TECHNICAL_ASSISTANCE]: (state, payload) => {
      state.technicalAssistance = payload;
    },
    [EVENTS.SET_SCHEDULE]: (state, payload) => {
      state.schedule = payload;
    },
  },
  actions: {
    [EVENTS.FETCH_EVENTS]: async ({ commit, getters }, requestOptions) => {
      try {
        const payloadHash = sha1(JSON.stringify(requestOptions));
        if (
          !eventPromise ||
          eventPromise.hash !== payloadHash ||
          moment().isAfter(eventPromise.expiration)
        ) {
          const { types } = requestOptions.params;
          // console.warn('FETCH_EVENTS creating promise', payload);
          eventPromise = {
            hash: payloadHash,
            promise: requestService(
              process.env.EVENT_API_URL,
              'GET',
              requestOptions
            ),
            expiration: moment().add(5, 'minutes').toDate(),
          };

          const eventTypes = await eventPromise.promise;

          for (const eventType of types) {
            if (Object.hasOwnProperty.call(eventTypes, eventType)) {
              const events = eventTypes[eventType];
              commit(EVENTS[`UPDATE_${eventType.toUpperCase()}`], events);
            }
          }
          commit(NOTIFICATIONS.MUTATE_EVENT, getters[EVENTS.GET_APPOINTMENT]);
          return eventTypes;
        } else {
          // console.warn(
          //   'FETCH_EVENTS using promise',
          //   eventPromise.hash,
          //   eventPromise.expiration
          // );
          const eventTypes = await eventPromise.promise;
          return eventTypes;
        }
      } catch (error) {
        console.error(error);
        eventPromise = null;
      }
    },

    [EVENTS.FETCH_TECHNICAL_ASSISTANCE]: async (
      { state, commit, getters },
      payload
    ) => {
      const kitfixUrl = getters[CONFIG.GET_KITFIX_URL];
      if (!kitfixUrl) {
        return;
      }
      const unitObj = getters[UNIT.GET_SELECTED];
      const technicalAssistanceParams = { sku: unitObj.sku };
      const technicalAssistanceParamsString = JSON.stringify(
        technicalAssistanceParams
      );
      if (
        getters[EVENTS.GET_TECHNICAL_ASSISTANCE] != null &&
        state.technicalAssistanceParams == technicalAssistanceParamsString
      )
        return;
      if (state.loadingTechnicalAssistance) return;
      try {
        state.loadingTechnicalAssistance = true;
        state.technicalAssistanceParams = technicalAssistanceParamsString;

        const now = new Date().toISOString();

        let workOrders = await requestService(
          `${kitfixUrl}/api/workOrder/getScheduledWorkOrdersInfoBySku`,
          'GET',
          { params: technicalAssistanceParams }
        );
        workOrders = workOrders.filter(
          (workOrder) => workOrder.scheduleDate > now
        );

        if (workOrders !== null && workOrders !== undefined) {
          const result = workOrders.map((item) => {
            const defaultTimezoneDate = toDefaultTimezone(item.scheduleDate);
            return {
              _id: item.idTicket,
              date: item.scheduleDate,
              createdAt: item.workOrderFirstDateCreation,
              hour: defaultTimezoneDate.format('HH:mm'),
              day: defaultTimezoneDate.format('DD/MM'),
              weekDay: defaultTimezoneDate.format('ddd'),
              title: 'Vistoria de Assistência Técnica',
              place: item.local,
              ticketId: item.idTicket,
              ticketNumber: item.workOrders[0].ticketNumber,
              typeEvent: EVENT_TYPES.technicalAssistance,
              scheduleId: item.idSchedule,
              sku: item.sku,
              requesterName: item.requesterName,
              requesterDocument: item.requesterDocument,
              reasons: item.workOrders
                .filter((wo) => wo.nameReason != null)
                .map((wo) => ({
                  reason: wo.nameReason,
                  subReason: wo.nameSubReason,
                  idReason: wo.idReason,
                  idSubReason: wo.idSubReason,
                })),
              reasonsByDescription: item.workOrders
                .filter(
                  (wo) =>
                    wo.nameReason == null &&
                    wo.description != null &&
                    wo.description.length
                )
                .map((wo) => ({
                  reason: wo.description,
                  subReason: '',
                  idReason: null,
                  idSubReason: null,
                })),
              accompanied: {
                name: item.workOrders[0].companionName,
                document: item.workOrders[0].companionDocument,
              },
            };
          });
          commit(EVENTS.SET_TECHNICAL_ASSISTANCE, result);
          return result;
        } else {
          commit(EVENTS.SET_TECHNICAL_ASSISTANCE, []);
          return [];
        }
      } finally {
        state.loadingTechnicalAssistance = false;
      }
    },
    [EVENTS.FETCH_SCHEDULE]: async (
      { state, commit, getters, dispatch },
      payload
    ) => {
      if (state.loadingSchedule) return;
      if (state.scheduleParams) return;
      try {
        state.loadingSchedule = true;
        if (getters[UNIT.GET_IS_SYNDIC] === false) {
          const unitObj = getters[UNIT.GET_SELECTED];
          const usernames = getUnitProposersInfo(unitObj, 'document');
          const params = {
            usernames,
            desiredFields: {
              _id: 1,
              eventId: 1,
              date: 1,
              createdAt: 1,
              address: 1,
              targetEventType: 1,
              Evento: 1,
              'user.username': 1,
            },
            sku: unitObj.sku,
          };
          state.scheduleParams = { ...params };
          const url = `${process.env.SCHEDULE_API_URL}`;
          const data = await requestService(url, 'GET', {
            params,
          });

          if (data !== null && data !== undefined) {
            const result = data.map((item) => {
              const defaultTimezoneDate = toDefaultTimezone(item.date);
              return {
                _id: item._id,
                date: item.date,
                createdAt: item.createdAt,
                hour: defaultTimezoneDate.format('HH:mm'),
                day: defaultTimezoneDate.format('DD/MM'),
                weekDay: defaultTimezoneDate.format('ddd'),
                title: item.Evento,
                place: item.address,
                eventId: item.eventId,
                typeEvent: item.targetEventType,
              };
            });
            commit(EVENTS.SET_SCHEDULE, result);
          }
        }
      } catch (error) {
        state.scheduleParams = null;
      } finally {
        state.loadingSchedule = false;
      }
    },
  },
};

function filterDataBySameOrAfterDate(data) {
  if (data !== null && data !== undefined) {
    const today = moment().startOf('day');
    if (Array.isArray(data)) {
      data = data.filter((item) => moment(item.date).isSameOrAfter(today));
    } else if (!moment(data.date).isSameOrAfter(today)) {
      data = null;
    }
  }
  return data;
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js